<template>
  <div class="bigbox_right">
    <div v-if="right_options == 1">
      <div class="bigbox_top">
        <div class="bigbox_top_title">
          <img src="../../public/img/right/title_1.png" alt="" />
        </div>
        <div class="bigbox_top_content">港、美、A股一站式投资平台</div>
        <div class="bigbox_top_img">
          <img src="../../public/img/right/iphone_ipad.png" alt="" />
        </div>
        <div class="bigbox_top_button">下载APP</div>
      </div>
    </div>

    <div v-if="right_options == 1">
      <div class="bigbox_gaikuang">
        <div class="bigbox_gaikuang_title">
          <div class="bigbox_gaikuang_title_text1">公司概况</div>
          <div class="bigbox_gaikuang_title_text2">
            更多 <img src="../../public/img/right/xiala_right.png" alt="" />
          </div>
        </div>
        <div class="bigbox_gaikuang_content">
          碧桂园服务控股有限公司是一家中国住宅物业管理服务商。该公司主要提供物业管理服务、社区增值服务和非业主增值服务。物业管理服务包括保安、开荒清洁、绿化、园艺及维修保养服务等。社区增值服务包括到家服务、家装服务、社区传媒服务、增值创新服务、房地产经纪服务和园区空间服务。非业主增值服务包括物业开发商的售前业务管理咨询服务,以及为其他物业管理公司管理的物业提供咨询服务;在交付前阶段向物业开发商提供开荒清洁、绿化及维修保养服务;车位及房屋尾盘的代理销售及租赁服务。
          <div class="bigbox_gaikuang_content_zhankai">展开</div>
        </div>
        <div class="bigbox_gaikuang_bottom">
          <div>董事长：杨惠妍</div>
          <div>所属市场：香港主板</div>
          <div>上市日期：2018/06/19</div>
        </div>
      </div>
    </div>

    <div v-if="right_options == 1">
      <div class="bigbox_gaoguanjeishao">
        <div class="bigbox_gaoguanjeishao_text1">高管介绍</div>
        <div class="bigbox_gaoguanjeishao_text2">
          更多 <img src="../../public/img/right/xiala_right.png" alt="" />
        </div>
      </div>
      <div class="bigbox_gaoguanjeishao">
        <div class="bigbox_gaoguanjeishao_text1">三张表</div>
        <div class="bigbox_gaoguanjeishao_text2">
          更多 <img src="../../public/img/right/xiala_right.png" alt="" />
        </div>
      </div>
      <div class="bigbox_gaoguanjeishao">
        <div class="bigbox_gaoguanjeishao_text1">研报</div>
        <div class="bigbox_gaoguanjeishao_text2">
          更多 <img src="../../public/img/right/xiala_right.png" alt="" />
        </div>
      </div>
    </div>

    <div style="background-color: #fff; padding: 24px 24px 0 24px">
      <div class="bigbox_right_title">
        <div
          class="bigbox_right_title_text1"
          :class="{ bigbox_right_title_text2: options == 0 }"
          @click="change_option(0)"
        >
          我的自选
        </div>
        <div
          class="bigbox_right_title_text1"
          :class="{ bigbox_right_title_text2: options == 1 }"
          @click="change_option(1)"
        >
          最近浏览
        </div>
      </div>
      <div class="bigbox_right_table1" style="font-size: 16px">
        <div class="bigbox_right_table1_td1">名称|代码</div>
        <div class="bigbox_right_table1_td2">价格</div>
        <div class="bigbox_right_table1_td3">涨跌幅</div>
      </div>
      <div
        class="bigbox_right_table1"
        v-for="(item, index) in gptj"
        :key="index"
        @click="goto_info"
      >
        <div class="bigbox_right_table1_td1">
          <div style="font-size: 16px; font-weight: bold">
            {{ item.name }}
          </div>
          <div>{{ item.code }}</div>
        </div>
        <div class="bigbox_right_table1_td2">
          <div style="color: #fd4c4c">{{ item.price }}</div>
          <div style="color: #999999">{{ item.last_price }}</div>
        </div>
        <div class="bigbox_right_table1_td3">
          <div style="color: #fd4c4c">{{ item.zdf }}</div>
          <div style="color: #999999">{{ item.last_zdf }}</div>
        </div>
      </div>
      <div class="bigbox_right_table1" style="border-bottom: none">
        <div
          class="bigbox_right_table1_td2"
          style="font-size: 16px; color: #666666; cursor: pointer"
        >
          换一批
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      right_options: 0,
      options: 0,
      gptj: [
        {
          name: "九龙仓集团",
          code: 603077,
          price: 27.95,
          last_price: null,
          zdf: "+16.05%",
          last_zdf: null,
        },
        {
          name: "苹果",
          code: 603077,
          price: 27.95,
          last_price: 171.3,
          zdf: "+16.05%",
          last_zdf: "-0.48%",
        },
        {
          name: "九龙仓集团",
          code: 603077,
          price: 27.95,
          last_price: null,
          zdf: "+16.05%",
          last_zdf: null,
        },
        {
          name: "苹果",
          code: 603077,
          price: 27.95,
          last_price: 171.3,
          zdf: "+16.05%",
          last_zdf: "-0.48%",
        },
        {
          name: "九龙仓集团",
          code: 603077,
          price: 27.95,
          last_price: null,
          zdf: "+16.05%",
          last_zdf: null,
        },
        {
          name: "苹果",
          code: 603077,
          price: 27.95,
          last_price: 171.3,
          zdf: "+16.05%",
          last_zdf: "-0.48%",
        },
        {
          name: "九龙仓集团",
          code: 603077,
          price: 27.95,
          last_price: null,
          zdf: "+16.05%",
          last_zdf: null,
        },
        {
          name: "苹果",
          code: 603077,
          price: 27.95,
          last_price: 171.3,
          zdf: "+16.05%",
          last_zdf: "-0.48%",
        },
      ], //right  人们推荐股票
    };
  },
  methods: {
    //点击进入股票详情页
    goto_info() {
      // this.$router.push({ name: "shares_Info" });
    },
    //我的自选 最近浏览 点击切换
    change_option(e) {
      this.options = e;
    },
  },
  props: {
    route: {
      type: String,
    },
  },
  mounted() {

  },
  watch: {
   
  },
};
</script>

<style scoped>
.bigbox_right {
  height: 100%;
}
.bigbox_right {
  max-width: 300px;
  min-width: 300px;
  min-height: 670px;
  min-height: 770px;
  height: calc(100vh - 96px);
  background-color: #f3f3f3;
  overflow-y: scroll;
  margin-top: 96px;
  /* padding: 0px 24px 0 24px; */
}
.bigbox_right_title {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0px;
  color: #000000;
  display: flex;
  margin-bottom: 18px;
}
.bigbox_right_title_text1 {
  font-size: 18px;
  color: #666666;
  width: 100px;
  text-align: left;
  position: relative;
  cursor: pointer;
}

.bigbox_right_title_text2 {
  font-weight: bold;
  color: #000000;
}
.bigbox_right_title_text2::after {
  content: " ";
  display: block;
  width: 60px;
  height: 4px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -6px;
  left: 7px;
}
.bigbox_right_table1 {
  display: flex;
  padding: 18px 0;
  width: 252px;
  justify-content: space-between;
  font-size: 14px;
  color: #000000;
  border-bottom: 1px solid rgba(223, 223, 223, 0.3);
}
.bigbox_right_table1_td1 {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  flex: 2;
  text-align: left;
}
.bigbox_right_table1_td2 {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  flex: 1;
  text-align: center;
}
.bigbox_right_table1_td3 {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  flex: 1;
  text-align: right;
}
.bigbox_top {
  width: 100%;
  height: 386px;
  background-color: #fff;
  margin-bottom: 24px;
  border-radius: 3px;
  overflow: hidden;
}
.bigbox_top_title {
  text-align: center;
  margin-top: 28px;
}
.bigbox_top_title img {
  width: 163px;
}
.bigbox_top_content {
  font-size: 18px;
  text-align: center;
  color: #333333;
  margin-top: 20px;
}
.bigbox_top_img {
  margin-top: 30px;
}
.bigbox_top_img img {
  width: 100%;
}
.bigbox_top_button {
  width: 204px;
  height: 42px;
  background-color: #fcad2a;
  border-radius: 21px;
  margin: 0 auto;
  margin-top: 15px;
  text-align: center;
  line-height: 42px;
  font-size: 18px;
  cursor: pointer;
  color: #ffffff;
}
.bigbox_gaikuang {
  width: calc(100% - 44px);
  height: 335px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 24px;
  padding: 20px 22px 0 22px;
}
.bigbox_gaikuang_title {
  display: flex;
  justify-content: space-between;
}
.bigbox_gaikuang_title_text1 {
  font-size: 18px;
  color: #000000;
}
.bigbox_gaikuang_title_text2 {
  font-size: 16px;
  color: #666666;
}
.bigbox_gaikuang_title_text2 img {
  width: 7px;
  height: 13px;
}
.bigbox_gaikuang_content {
  width: 252px;
  height: 186px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  margin-top: 20px;
  overflow: hidden;
  position: relative;
}
.bigbox_gaikuang_content_zhankai {
  width: 57px;
  height: 15px;
  line-height: 15px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: right;
  font-size: 14px;

  color: #fcad2a;
}
.bigbox_gaikuang_bottom {
  font-size: 14px;
  line-height: 24px;
  color: #333333;
  margin-top: 15px;
  font-weight: 550;
}
.bigbox_gaoguanjeishao {
  width: 256px;
  height: 64px;
  line-height: 64px;
  padding: 0 22px;
  background-color: #ffffff;
  border-radius: 3px;
  margin-bottom: 24px;
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.bigbox_gaoguanjeishao_text1 {
  font-size: 18px;
  color: #000000;
  font-weight: 550;
}
.bigbox_gaoguanjeishao_text2 {
  font-size: 16px;
  color: #666666;
}
.bigbox_gaoguanjeishao_text2 img {
  width: 7px;
  height: 13px;
}
</style>